import { useMemo } from "react";
import type { ScheduleDefaults } from "./applyCloseTemplate.schema";
import type { ServiceTemplateScheduleOccurrenceRow } from "./serviceTemplateScheduleOccurrencesViewConfig";
import { computeScheduleWizardPreviewOccurrences } from "./scheduleWizardOccurrences.util";

/** Memoized preview of the occurrences a schedule would create, shared by the schedule-defaults step and the apply wizard body. */
export function useScheduleWizardPreviewOccurrences(
    schedule: ScheduleDefaults | undefined,
): ServiceTemplateScheduleOccurrenceRow[] {
    return useMemo(
        () =>
            schedule ? computeScheduleWizardPreviewOccurrences(schedule) : [],
        [schedule],
    );
}
